var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 21,
    viewBox: "0 0 57 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 57,
    height: 20,
    rx: 10,
    fill: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 29,
    height: 14,
    rx: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1558 10.5C14.1558 11.3542 13.9995 12.0885 13.687 12.7031C13.3745 13.3151 12.9461 13.7865 12.4019 14.1172C11.8602 14.4453 11.2443 14.6094 10.5542 14.6094C9.86149 14.6094 9.243 14.4453 8.69873 14.1172C8.15706 13.7865 7.72998 13.3138 7.41748 12.6992C7.10498 12.0846 6.94873 11.3516 6.94873 10.5C6.94873 9.64583 7.10498 8.91276 7.41748 8.30078C7.72998 7.6862 8.15706 7.21484 8.69873 6.88672C9.243 6.55599 9.86149 6.39062 10.5542 6.39062C11.2443 6.39062 11.8602 6.55599 12.4019 6.88672C12.9461 7.21484 13.3745 7.6862 13.687 8.30078C13.9995 8.91276 14.1558 9.64583 14.1558 10.5ZM12.9604 10.5C12.9604 9.84896 12.855 9.30078 12.644 8.85547C12.4357 8.40755 12.1493 8.06901 11.7847 7.83984C11.4227 7.60807 11.0125 7.49219 10.5542 7.49219C10.0933 7.49219 9.6818 7.60807 9.31982 7.83984C8.95785 8.06901 8.67139 8.40755 8.46045 8.85547C8.25212 9.30078 8.14795 9.84896 8.14795 10.5C8.14795 11.151 8.25212 11.7005 8.46045 12.1484C8.67139 12.5937 8.95785 12.9323 9.31982 13.1641C9.6818 13.3932 10.0933 13.5078 10.5542 13.5078C11.0125 13.5078 11.4227 13.3932 11.7847 13.1641C12.1493 12.9323 12.4357 12.5937 12.644 12.1484C12.855 11.7005 12.9604 11.151 12.9604 10.5ZM15.6606 14.5V6.5H20.6216V7.53906H16.8677V9.97656H20.2661V11.0117H16.8677V14.5H15.6606ZM22.106 14.5V6.5H27.0669V7.53906H23.313V9.97656H26.7114V11.0117H23.313V14.5H22.106Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOff);
export default __webpack_public_path__ + "static/media/switchOff.f277f6da0df6803f3e6a2b454b8d7b1f.svg";
export { ForwardRef as ReactComponent };